__turbopack_context__.v({
  "container": "FormInput-module-scss-module__CfHF2G__container",
  "label": "FormInput-module-scss-module__CfHF2G__label",
  "readOnly": "FormInput-module-scss-module__CfHF2G__readOnly",
  "spacer": "FormInput-module-scss-module__CfHF2G__spacer",
  "valid": "FormInput-module-scss-module__CfHF2G__valid",
});
